// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a286bead","703":"e6ae48fd"}[chunkId] + ".chunk.js";
};